import { render, staticRenderFns } from "./BatchTransferDetail.vue?vue&type=template&id=3eeec66e"
import script from "./BatchTransferDetail.vue?vue&type=script&lang=js"
export * from "./BatchTransferDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/batch-transfer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports